import symbolImage from "../../Media/symbol.png";
import "./RegistrationSuccess.css"
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";

export default function RegistrationSuccess() {
  const navigate = useNavigate();
  return (
    <>
      <Button
        variant="outlined"
        className="login-button-backtologin"
        sx={{ width: "200px"}}
        onClick={() => navigate("/")}
      >
        <ArrowBackIcon />
        Back to Login
      </Button>
      <div className="container">

        <div className="content">
          <div className="contentSub">
            <table
              border="0"
              width="100%"
              align="center"
              style={{ marginTop: "50px" }}
            >
              <tr>
                <td colSpan={2}>
                  <div className="page-subtitle">
                    <h2>Your account has been created.</h2>
                  </div>
                </td>
              </tr>
              <tr>
                <td width="60" height="60" valign="bottom">
                  <img src={symbolImage} alt="Symbol" />
                </td>
                <td>
                  <p
                    style={{
                      fontWeight: "bold",
                      background: "#eee",
                      border: "1px solid #ccc",
                      padding: "10px",
                      lineHeight: "140%",
                      margin: "0px",
                    }}
                  >
                    We have just sent a verification email to the email address
                    provided on the registration page. Before you can login to{" "}
                    <br />
                    FIRST, VERIFY you will need to visit the link contained in the
                    email to verify your email address and activate your account.
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan={2} height="50">
                  <p>
                    Most emails are delivered in 1-2 minutes, however it can take
                    longer in some cases. If you have not received your
                    verification email in 30 minutes, please contact our support
                    team:
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan={2} height="40">
                  <a href="mailto:notification@firstverify.com">
                    notification@firstverify.com
                  </a>
                </td>
              </tr>

              <tr>
                <td colSpan={2} height="10">
                  (402)562-5930
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </>);
}
